import { createSelector } from 'reselect';
const currentUserStateSelector = ({ currentUser }) => currentUser;

export const getCurrentUser = createSelector(
  currentUserStateSelector,
  currentUser => currentUser
);



// WEBPACK FOOTER //
// ./src/redux-modules/current-user/selectors/index.js